module.exports = "/assets/9ae91e2783c255e81e9831b87140a1c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/icon/stop.png
// module id = 3553
// module chunks = 0